import { Controller } from "@hotwired/stimulus";
import Cleave from "cleave.js";

export default class extends Controller {
  static targets = ["formattedPrice", "pricePoint", "validationMessage", "destroyField"];

  connect() {
    this.initializeCleave();
    this.validatePricePoints();

    // Add event listeners to all required fields to validate on change
    this.pricePointTargets.forEach(pricePoint => {
      const requiredFields = pricePoint.querySelectorAll('input[required], select[required]');
      requiredFields.forEach(field => {
        field.addEventListener('change', () => this.validatePricePoints());
        field.addEventListener('input', () => this.validatePricePoints());
      });
    });
  }

  initializeCleave() {
    this.formattedPriceTargets.forEach((input) => {
      new Cleave(input, {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalMark: '.',
        delimiter: ',',
        prefix: '$'
      });
    });
  }

  validatePricePoints() {
    const remainingPricePoints = this.getRemainingPricePoints();
    let validationTuple;

    if (remainingPricePoints === 0) {
      validationTuple = { valid: false, className: 'invalid', message: '<i class="fa fa-times-circle"></i> You must have at least one price point to save the camp.' };
    } else {
      // Check if required fields are filled for visible price points
      const allRequiredFieldsFilled = this.areAllRequiredFieldsFilled();

      if (allRequiredFieldsFilled) {
        validationTuple = { valid: true, className: 'valid', message: '<i class="fa fa-check-circle"></i> Success!' };
      } else {
        validationTuple = { valid: false, className: 'invalid', message: '<i class="fa fa-exclamation-circle"></i> Please fill out all required fields.' };
      }
    }

    const valMessage = this.validationMessageTarget;
    valMessage.classList.remove('valid', 'invalid');
    valMessage.classList.add(validationTuple.className);
    valMessage.innerHTML = validationTuple.message;

    return {
      valid: validationTuple.valid,
      message: validationTuple.message
    };
  }

  // New method to check if all required fields have values
  areAllRequiredFieldsFilled() {
    // Only check visible price points
    const visiblePricePoints = this.pricePointTargets.filter(pp => pp.style.display !== "none");

    return visiblePricePoints.every(pricePoint => {
      const requiredFields = pricePoint.querySelectorAll('input[required], select[required]');
      return Array.from(requiredFields).every(field => {
        // For text fields, check if they have a non-empty value
        if (field.type === 'text' || field.type === 'number') {
          return field.value.trim() !== '';
        }

        // For select fields, check if a non-empty option is selected
        if (field.tagName === 'SELECT') {
          return field.value !== '';
        }

        return true; // Other field types are considered valid
      });
    });
  }

  getValidationTuple(remainingCount) {
    if (remainingCount === 0) {
      return { valid: false, className: 'invalid', message: '<i class="fa fa-times-circle"></i> You must have at least one price point to save the camp.' };
    } else {
      return { valid: true, className: 'valid', message: '<i class="fa fa-check-circle"></i> Success!' };
    }
  }

  addPricePoint(event) {
    event.preventDefault();
    const time = new Date().getTime();
    const addButton = event.currentTarget;
    const regexp = new RegExp(addButton.dataset.id, 'g');
    const template = addButton.dataset.fields.replace(regexp, time);
    addButton.insertAdjacentHTML('beforebegin', template);
    this.initializeCleave();

    // Add event listeners to newly added form fields
    const newPricePoint = addButton.previousElementSibling;
    if (newPricePoint && this.pricePointTargets.includes(newPricePoint)) {
      const requiredFields = newPricePoint.querySelectorAll('input[required], select[required]');
      requiredFields.forEach(field => {
        field.addEventListener('change', () => this.validatePricePoints());
        field.addEventListener('input', () => this.validatePricePoints());
      });
    }

    this.validatePricePoints();
  }

  removePricePoint(event) {
    event.preventDefault();
    const fieldset = event.currentTarget.closest("fieldset.price-point");
    const markToDelete = fieldset.querySelector("input.destroy-field");

    const fields = fieldset.querySelectorAll("input");
    fields.forEach(field => field.removeAttribute('required'));
    if (markToDelete) {
      markToDelete.value = "1";
    } else {
      console.error("No input.destroy-field found within the fieldset.");
    }
    fieldset.style.display = "none";
    this.validatePricePoints();
  }

  getRemainingPricePoints() {
    const remaining = this.pricePointTargets.filter(pp => pp.style.display !== "none").length;
    console.log("Remaining price points:", remaining);
    return remaining;
  }
}